import DataService from "@/services/data.service"
import ObjectTypesService from "@/services/object_types.service"
import { utils } from "@/store/helpers"

const initialState = {
  solid_metrics_phases: {},
  solid_metrics_growth: {},
  solid_metrics_suggested: {},
  metrics_tags: [
    { label: "Health Score", value: "health_score" },
    { label: "Usage", value: "usage" },
    { label: "Adoption", value: "adoption" },
    { label: "Product(s)", value: "product" },
    { label: "CS Score", value: "cs_score" },
    { label: "Potential Expansion", value: "potential_expansion" },
    { label: "Annual Recurring Revenue (ARR)", value: "annual_recurring_revenue" },
    { label: "Monthly Recurring Revenue (MRR)", value: "monthly_recurring_revenue" },
    { label: "Total Contract Value (TCV)", value: "total_contract_value" },
    { label: "Current Contract Start Date", value: "current_contract_start_date" },
    { label: "Current Contract End Date", value: "current_contract_end_date" },
    { label: "Position/Role", value: "position_role" },
    { label: "Decision Maker", value: "decision_maker" },
    { label: "Influencer", value: "influencer" }
  ],
  metric_action_options: [{ for: "number_string_date_time_list_plan_goal_task_interaction_milestone", label: "update to", value: "=" }]
}

export const object_types_manager = {
  namespaced: true,
  state: initialState,
  actions: {
    async getObjectTypes({ commit, dispatch }) {
      return ObjectTypesService.getObjectTypes({ page_size: 500 }).then(
        (response) => {
          // Optionally trigger object types mapping update if needed
          dispatch("integration/getObjectTypesMapping", null, { root: true })
          commit("setObjectTypes", response.data, { root: true })

          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async addObjectType({ rootState, commit }, data) {
      return await ObjectTypesService.createObjectType(data).then(
        (response) => {
          let objectTypes = utils.replaceOrAddItem(rootState.object_types, response.data)
          commit("setObjectTypes", objectTypes, { root: true })

          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async updateObjectType({ rootState, commit }, objectType) {
      return await ObjectTypesService.updateObjectType(objectType.id, objectType).then(
        (response) => {
          let objectTypes = utils.replaceOrAddItem(rootState.object_types, response.data)
          commit("setObjectTypes", objectTypes, { root: true })
          return Promise.resolve(objectTypes)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async deleteObjectType({ rootState, commit }, objectType) {
      return await ObjectTypesService.deleteObjectType(objectType.id).then(
        () => {
          let objectTypes = utils.removeItem(rootState.object_types, objectType, "id")
          commit("setObjectTypes", objectTypes, { root: true })
          return Promise.resolve(objectTypes)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getMetrics({ commit, dispatch }) {
      return DataService.getOrganizationMetrics({ page_size: 500 }).then(
        (response) => {
          // Optionally trigger metrics mapping update if needed
          dispatch("integration/getMetricsMapping", null, { root: true })
          commit("setMetrics", response.data.results, { root: true })

          return Promise.resolve(response.data.results)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async addMetric({ rootState, commit }, data) {
      return await DataService.addOrganizationMetric(data).then(
        (response) => {
          let metrics = utils.replaceOrAddItem(rootState.metrics, response.data)
          commit("setMetrics", metrics, { root: true })

          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async updateMetric({ rootState, commit }, metric) {
      return await DataService.updateOrganizationMetric(metric).then(
        (response) => {
          let metrics = utils.replaceOrAddItem(rootState.metrics, response.data)
          commit("setMetrics", metrics, { root: true })
          return Promise.resolve(metrics)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async deleteMetric({ rootState, commit }, metric) {
      return await DataService.deleteOrganizationMetric(metric.id).then(
        () => {
          let metrics = utils.removeItem(rootState.metrics, metric, "id")
          commit("setMetrics", metrics, { root: true })
          return Promise.resolve(metrics)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    bulkRecordsMetricUpdate(_, data) {
      return DataService.bulkRecordsMetricUpdate(data).then(
        (response) => {
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    mergeMetricsValues(_, data) {
      return DataService.mergeMetricsValues(data).then(
        (response) => {
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    }
  },
  mutations: {
    updatePhasesSolidMetrics(state, { id, list }) {
      state.solid_metrics_phases[id] = list
    },
    updateGrowthSolidMetrics(state, { id, list }) {
      state.solid_metrics_growth[id] = list
    },
    updateSuggestedSolidMetrics(state, { id, list }) {
      state.solid_metrics_suggested[id] = list
    }
  }
}
